import Header from "@/components/layout/Header"
import Footer from "@/components/layout/Footer"

// 💡 개인정보처리방침 내용을 상단 변수로 분리
const PRIVACY_CONTENT = `쇼핑몰 MG퀵플라워 개인정보 보호 정책
-------------------------
MG퀵플라워는 고객님들의 개인정보를 매우 소중하게 생각하여 다음과 같은 개인정보보호정책을 시행하고 있습니다. 이 개인정보보호정책은 개인정보보호와 관련한 법률 또는 지침의 변경, 회사 정책의 변화에 따라 달라질 수 있으니 고객님께서는 MG퀵플라워 방문시 수시로 확인하시기 바랍니다.

1. 개인정보 수집목적 및 이용목적 ,수집범위
MG퀵플라워이 고객님들의 개인정보를 수집하는 목적은 고객님들의 신분을 확인 및 MG퀵플라워 서비스를 이용하고자하는 의사를 확인하여 고객님에게 최적의 서비스를 제공하고자 하는 것입니다.
MG퀵플라워은 인터넷 전자상거래회사(쇼핑몰)로서 전자상거래 및 이와 관련한 다양한 서비스를 고객님들의 특성, 기호에 맞추어 제공하고 고객님이 MG퀵플라워의 서비스를 이용함에 따라 일어나는 문제를 해결하기 위해 일부 한정된 범위내에서 개인정보를 이용하고 있습니다. MG퀵플라워은 회원가입시 성명, 주소, 휴대폰번호, E-mail주소를 필수적으로 수집하며 고객님에게 MG퀵플라워의 다양한 서비스를 제공하기 위하여 고객님의 선택에 따라 등록한 취미등의 정보를 수집할 수 있습니다. 이 이외에 MG퀵플라워이 제공하는 특정한 서비스를 위하여 고객님께 추가정보를 요청하고 수집할 수 있습니다.

2. 개인정보수집에 대한 동의
MG퀵플라워은 회원가입시 이용약관을 동의하는 절차가 있으며 동의를 하시면 개인정보수집에 대해 동의한것으로 간주합니다.

3. 쿠키에 의한 개인정보 수집
MG퀵플라워은 고객님께 다양하고 특화된 서비스를 제공하기 위하여 고객님에 대한 정보를 저장하고 수시로 찾아내는 쿠키를 사용합니다. 쿠키란 웹사이트서버가 사용자의 컴퓨터 브라우저에게 전송하는 소량의 정보입니다.
고객님께서 MG퀵플라워 인터넷사이트에 접속을 하면 고객님의 컴퓨터는 브라우저에 저장되어 있는 쿠키의 내용을 읽고, 고객님의 추가정보를 컴퓨터에서 찾아 접속에 따른 성명 등의 추가 입력없이
서비스를 제공할 수 있습니다. 쿠키는 고객님의 컴퓨터는 식별하지만 고객님을 개인적으로 식별하지는 않습니다. 또한 고객님은 쿠키에 대한 선택권이 있습니다. 고객님의 웹브라우저를 조정함으로써 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있습니다. 다만 쿠키의 저장을 거부하는 경우에는 MG퀵플라워에서 로그인이 필요한 모든 서비스는 이용하실 수 없습니다.

4. 개인정보의 목적외 사용 및 제3자 제공
MG퀵플라워는 고객님의 개인정보를 수집목적 및 이용목적을 초과하여 이용하거나 타인 또는 타기관에 제공하지 않습니다.단, 법률에 특별한 규정이 있는 경우, 범죄의 수사,법원의 재판업무수행을 위해 필요한 경우, 귀하의 동의가 있거나 귀하에게 제공하는 경우, 통계목적,학술연구 등의 목적을 위한 경우로서 특정 개인을 식별할.수 없는 형태로 정보가 제공되는 경우등은 예외입니다.

5. 개인정보의 열람 및 정정
귀하는 언제든지 등록되어 있는 귀하의 개인정보를 열람하거나 정정하실 수 있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 개인정보관리책임자에게 연락하시면 조치하여 결과를 통보해 드립니다.
MG퀵플라워는 귀하의 개인정보를 데이터베이스 형태로 관리하지 않기 때문에 웹사이트에서 직접 열람하거나 정정할 수는 없습니다.귀하가 개인정보 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용하지 않습니다.

6. 개인정보 수집·이용·제공에 대한 동의철회
고객님은 개인정보침해 신고 및 상담 신청을 위해 개인정보 수집·이용·제공에 대해 동의하신 내용을 언제든지 철회하실 수 있습니다. 동의철회는 개인정보관리책임자에게 연락하시면 조치하여 결과를 통보해 드립니다. 단, 동의철회를 하신 경우 개인정보침해 신고에 대한 조사는 중지될 수 있습니다.

7. 개인정보의 이용기간 및 보유기간
이용기간 : 고객님의 개인정보는 개인정보침해 신고 조사 및 상담 신청에 대한 답변, 그리고 정부에 의한 후속조치 기간 동안 이용됩니다.
보유기간 : 『공공기관의기록물관리에관한법률시행령』제15조제1항에 의거하여, MG퀵플라워는 고객님의 개인정보의 수집목적 및 이용목적이 달성된 후, 개인정보침해 신고 처리기록중 중요하다고 판단되는 문서는 3년, 기타 신고 및 상담 처리기록은 컴퓨터파일이 아닌 문서로(off- line)1년 동안 보관합니다.

8. 개인정보보호를 위한 기술적대책
MG퀵플라워는 귀하의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다. 해킹 등에 의해 귀하의 개인정보가 유출되는 것을 방지하기 위해, 외부로부터의 침입을 차단하는장치를 이용하고 있으며, 서버에 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.

9. 의견수렴 및 불만처리
MG퀵플라워는 고객님의 개인정보수집과 관련하여 의견과 불만을 제기할 수 있는 창구를 개설하고 있습니다. 개인정보와 관련한 불만이 있으신 분은 MG퀵플라워의 개인정보관리책임자에게 의견을 주시면 조치하여 처리결과를 통보해 드립니다.

10. 개인정보의 위탁처리
MG퀵플라워는 고객님의 개인정보를 외부에 위탁처리하지 않습니다.

11. 아동의 개인정보보호
MG퀵플라워는 아동에게 유해한 정보를 게시하거나 제공하지 않기 때문에 아동으로부터 개인정보침해 신고 및 상담 신청을 받을 경우 법정대리인의 동의를 필요로 하지 않습니다. 따라서 아동도 본인이 직접 개인정보침해 신고 및 상담 신청을 할 수 있습니다.

12. 개인정보관리책임자
MG퀵플라워는 개인정보의 누출 및 오·남용 등으로 인한 피해를 방지하기 위하여 개인정보취급자를 최소한의 인원으로 제한하고 있으며, 개인정보 관리에 관한 실질적인 책임을 가진 대표자를 개인정보관리책임자로 지정하고 있습니다. MG퀵플라워의 개인정보관리책임자는 다음과 같습니다.

성 명 : 이수연 팀장
전화번호 : 02-3786-4377
e-mail : sylee@mgnetwork.co.kr`

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <Header />

      <main className="mx-auto max-w-4xl px-4 py-10 lg:px-6 lg:py-16">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-900">개인정보처리방침</h1>
          <p className="mt-2 text-sm text-slate-500">
            MG퀵플라워 서비스 이용을 위한 개인정보 보호 정책입니다.
          </p>
        </div>

        <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
          <div className="whitespace-pre-wrap text-sm leading-7 text-slate-600">
            {PRIVACY_CONTENT}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}